module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "md_xl",
      "disableOutsideClick": true,
      "title": _vm.header
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "h-full flex flex-col space-y-3 px-6 mb-4 overflow-y-auto"
  }, [_c('div', [_c('div', {
    attrs: {
      "id": "title-input flex flex-col space-y-2"
    }
  }, [_c('div', {
    staticClass: "text-sm text-blueGray-800 mb-2 font-poppins"
  }, [_c('span', [_vm._v("Title")]), _vm._v(" "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.point_title),
      expression: "point_title"
    }],
    staticClass: "bg-white text-sm text-blueGray-700 flex-grow outline-none border border-solid border-gray-200 focus-within:border-primary px-3 py-2 w-full rounded",
    domProps: {
      "value": (_vm.point_title)
    },
    on: {
      "keyup": function($event) {
        _vm.point_title_error_message = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.point_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow h-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2 w-full mb-3"
  }, [_c('div', {
    staticClass: "text-left text-blueGray-800 font-poppins"
  }, [_c('span', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "rounded w-full border border-solid border-gray-200"
  }, [_c('RichTextEditor', {
    attrs: {
      "api-key": "no-api-key",
      "id": "text-editor-point-description",
      "init": _vm.editor_options
    },
    model: {
      value: (_vm.point_description),
      callback: function($$v) {
        _vm.point_description = $$v
      },
      expression: "point_description"
    }
  })], 1)]), _vm._v(" "), (_vm.assessment_scale !== null) ? _c('div', {
    staticClass: "w-full"
  }, [_c('h3', {
    staticClass: "font-manrope text-base font-bold text-gray-800 mb-2.5"
  }, [_vm._v("Rubric Levels")]), _vm._v(" "), _vm._l((_vm.points_rubric_description), function(point, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "px-3 py-2 flex items-start space-x-2 border rounded border-solid border-gray-200 mb-2"
    }, [_c('div', [_c('div', {
      staticClass: "w-7 h-7 border border-solid border-gray-200 rounded flex justify-center items-center"
    }, [_c('span', [_vm._v(_vm._s(point.value))])])]), _vm._v(" "), _c('div', {
      staticClass: "w-full"
    }, [_c('textarea', {
      staticClass: "w-full resize-none px-2 py-1.5 border border-solid border-gray-200 rounded focus-within:border-primary outline-none",
      attrs: {
        "placeholder": "Enter a description for this level...."
      },
      domProps: {
        "value": point.description
      },
      on: {
        "input": function($event) {
          return _vm.handleUpdateDescription(index, $event.target.value)
        }
      }
    })])])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', [_c('button', {
    staticClass: "px-4 py-2 hover:bg-gray-50 rounded cursor-pointer text-blueGray-800 border border-solid border-gray-200 mr-1",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Cancel\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(!_vm.point_default) ? _c('button', {
    staticClass: "bg-white border border-solid px-5 py-2 text-red-500 rounded border-red-500 hover:bg-red-50",
    on: {
      "click": function($event) {
        return _vm.handleDeletePoint()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('i', {
    staticClass: "fa-regular fa-trash-can"
  })])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-2 bg-primary rounded border border-solid border-primary cursor-pointer text-white hover:bg-primary-dark",
    on: {
      "click": _vm.handleSavePoint
    }
  }, [_vm._v("\n          Save & Close\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a84e89b8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/createNewPointModal.vue
// module id = 1067
// module chunks = 61